
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      `404 Error: Page not found at path: ${location.pathname}`,
      {
        currentPath: location.pathname,
        search: location.search,
        hash: location.hash
      }
    );
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center max-w-md p-8">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">
          Страница не найдена
        </p>
        <p className="text-gray-500 mb-6">
          Запрошенный путь: {location.pathname}
        </p>
        <Link 
          to="/" 
          className="inline-block bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors"
        >
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
